// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

import { LoginResponseFragmentDoc } from '../auth/fragments/loginResponse.generated';
import { LoginResponseSuccessFragmentDoc } from '../auth/fragments/loginResponseSuccess.generated';
import { MeFragmentDoc } from '../fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../fragments/costumerConsultant.fragment.generated';
import { LoginResponseFailureFragmentDoc } from '../auth/fragments/loginResponseFailure.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const CreateCustomerThroughQuestionnaireWithoutQuestionnaireDocument = `
    mutation createCustomerThroughQuestionnaireWithoutQuestionnaire($input: CustomerRegistrationInput!, $type: QuestionnaireType!, $questionnaireSourceUrl: Uri, $isConsultant: Boolean!, $locale: Locale!) {
  createCustomerThroughQuestionnaireWithoutQuestionnaire(
    type: $type
    input: $input
    questionnaireSourceUrl: $questionnaireSourceUrl
  ) {
    __typename
    login {
      ...loginResponse
    }
  }
}
    ${LoginResponseFragmentDoc}
${LoginResponseSuccessFragmentDoc}
${MeFragmentDoc}
${CostumerConsultantFragmentDoc}
${LoginResponseFailureFragmentDoc}`;

export function useCreateCustomerThroughQuestionnaireWithoutQuestionnaireMutation() {
  return Urql.useMutation<SchemaTypes.CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutation, SchemaTypes.CreateCustomerThroughQuestionnaireWithoutQuestionnaireMutationVariables>(CreateCustomerThroughQuestionnaireWithoutQuestionnaireDocument);
};